<template>
  <div
    class="page-wraper"
    style="position: relative"
  >
    <dataForm
      :items="searchFormItems"
      ref="searchForm"
      class="search-form"
      autoSetFirstValue
    />
    <!-- :onOptionsLoadAfter="onOptionsLoadAfter" -->
    <div class="main">
      <div
        class="item"
        ref="dateList"
        style="padding: 14px"
      >
        <div
          class="before"
          @click="onLeft"
        >
          <img
            src="@/assets/image/left.png"
            width="15px"
            height="15px"
            alt=""
          />
        </div>
        <div
          class="date"
          ref="date"
        >
          <div
            class="date-screen-box"
            :style="{ width: dateBoxListWidth }"
          >
            <div
              class="date-item"
              v-for="(item, index) in dateList"
              :key="item.date"
              @click="changeDate(index)"
              :class="item.active ? 'active' : ''"
            >
              {{ item.date.substring(5, 10) }}
            </div>
          </div>
        </div>
        <div
          class="selectBox"
          @click="onRight"
        >
          <img
            src="@/assets/image/right.png"
            width="15px"
            height="15px"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="date-list"
      :style="{ height: dateListHeight, overflowY: 'scroll' }"
    >
      <div
        class="date-list-item"
        v-for="(item, index) in data"
        :key="item.RoomId"
      >
        <div class="class-info">
          <div class="class-info-text-box">
            <p class="build-name">{{ item.Name }}</p>
            <!-- <p class="class-name">{{ item.RoomId }}</p> -->
          </div>
          <div
            v-if="index != 4"
            class="border-bottom"
          ></div>
        </div>
        <div class="time-list">
          <p
            @click="onClickDate(index, index2)"
            v-for="(item2, index2) in getSelectDateData(item.Schedules)"
            :key="item2.BeginTime"
          >
            <van-popover
              v-model="item2.showTips"
              trigger="click"
            >
              <div style="
                  padding: 10px 20px;
                  color: #fff;
                  background-color: rgb(81, 194, 226);
                  max-width: 65vw;
                  font-size: 14px;
                ">
                <p
                  class="state"
                  v-if="item2.DisplayConfirmFlag"
                >审核中</p>
                <p>课程名称：{{ item2.CourseName }}</p>
                <p>
                  上课时间：{{ item2.Date }}&nbsp;&nbsp;{{ item2.BeginTime }}~{{
                    item2.EndTime
                  }}
                </p>
                <p>预订人：{{ item2.TeacherName }}</p>
                <p>班次名称：{{ item2.ClassName }}</p>
              </div>
              <template #reference>
                {{ item2.BeginTime }}-{{ item2.EndTime }}
              </template>
            </van-popover>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import classRoomApi from "@/api/classRoom.js";
import dataForm from "@/components/base/form/dataForm";
import moment from "moment";
export default {
  components: { dataForm },
  data () {
    const that = this;
    return {
      dateListHeight: "",
      data: [],
      showPopover: false,
      dateBoxListWidth: "200%",
      selectDate: "",
      dateList: [],
      startDate: "",
      endDate: "",
      screenWidth: 0,
      searchFormItems: [
        {
          title: "地点",
          field: "buildingCode",
          itemRender: {
            name: "a-select",
            props: {
              api: classRoomApi.QueryMeetingRoomBuildings,
              param: { FilterAccess: true },
              dataField: "Data",
              valueField: "BuildingCode",
              labelField: "Name",
              // defaultField: "IsSelected",
              titleWidth: "80px"
            },
            on: {
              change () {
                that.$nextTick(() => {
                  that.init();
                });
              }
            }
          }
        },
        {
          title: "日期",
          field: "date",
          itemRender: {
            name: "a-calendar",
            props: {
              titleWidth: "80px"
            },
            on: {
              change (date) {
                that.dateChange(date[0], date[1]);
              }
            }
          }
        }
      ]
    };
  },
  created () {
    // nextTick无效
    setTimeout(() => {
      this.startDate = moment().format("YYYY-MM-DD");
      this.endDate = moment()
        .add(6, "day")
        .format("YYYY-MM-DD");
      this.init();
      const screenHeight = window.innerHeight;
      const searchForm = this.$refs.searchForm.$el.offsetHeight;
      const dateList = this.$refs.dateList.offsetHeight;
      const tabHeight = 50;
      const footHeight = 76;
      const paddingNumber = 30;
      this.dateListHeight =
        screenHeight -
        searchForm -
        dateList -
        tabHeight -
        footHeight -
        paddingNumber +
        "px";
    }, 1000);
  },
  methods: {
    init () {
      this.selectDate = this.startDate;
      this.dateList = this.enumerateDaysBetweenDates(
        this.startDate,
        this.endDate
      );
      console.log(this.dateList);
      this.dateBoxListWidth = this.dateList.length * 15 + "vw";
      this.screenWidth = document.body.clientWidth;
      // 设置日期为七天前 - 今天
      this.$refs.searchForm.setData({
        date: [this.startDate, this.endDate]
      });
      this.getData();
    },
    dateChange (startDate, endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.init();
    },
    // 获取两个日期区间的所有日期
    enumerateDaysBetweenDates (startDate, endDate) {
      let daysList = [];
      const start = moment(startDate);
      const end = moment(endDate);
      const day = end.diff(start, "days");
      daysList.push({
        date: start.format("YYYY-MM-DD"),
        active: true
      });
      for (let i = 1; i <= day; i++) {
        daysList.push({
          date: start.add(1, "days").format("YYYY-MM-DD"),
          active: false
        });
      }
      return daysList;
    },
    changeDate (index) {
      this.dateList.map(item => {
        item.active = false;
      });
      this.dateList[index].active = true;
      this.selectDate = this.dateList[index].date;
      this.getData();
    },
    onRight () {
      this.$refs.date.scrollLeft += this.screenWidth / 3;
    },
    onLeft () {
      this.$refs.date.scrollLeft -= this.screenWidth / 3;
    },
    onClickDate (index, index2) {
      this.data[index].Schedules.map(item => {
        if (item.Date == this.selectDate) {
          item.Items[index2].showTips = true;
        } else {
          item.Items[index2].showTips = false;
        }
      });
    },
    getData () {
      const json = this.$refs.searchForm.getData();
      if (json.date && json.date.length) {
        json.BeginDate = json.date[0];
        json.EndDate = json.date[1];
      }
      json.FilterAccess = true;
      classRoomApi.QueryMeetingRoomApplies(json).then(res => {
        this.data = res.Data;
      });
    },
    getSelectDateData (allData) {
      let data = [];
      allData.map(item => {
        if (item.Date == this.selectDate) {
          data = item.Items;
        }
      });
      return data;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 0 10px 0px;
  background-color: rgb(255, 255, 255);

  .item {
    position: relative;
    padding: 16px;
    border-radius: 7px;
    background-color: rgb(248, 248, 248);
    margin-bottom: 10px;
    .title {
      font-weight: 900;
      color: rgb(51, 51, 51);
    }
    .before {
      margin-top: 2px;
    }
    .date {
      overflow: hidden;
      font-size: 8px;
      position: absolute;
      top: 50%;
      left: 50%;
      font-weight: 600;
      transform: translate(-50%, -50%);
      width: 80%;
      overflow-x: scroll;
      height: 100%;
      // justify-content: space-between;
      .date-screen-box {
        height: 100%;
        width: 500%;
        margin: 0 auto;
        .active {
          color: #fff;
          background-color: rgb(210, 0, 1);
        }
      }
      .date-item {
        padding: 18px 0;
        border-radius: 5px;
        width: 15vw;
        float: left;
        height: 100%;
        text-align: center;
        font-size: 14px;
      }
    }
    .selectBox {
      position: absolute;
      top: 18px;
      right: 44px;
      font-size: 12px;
      color: rgb(102, 102, 102);
      font-weight: 600;
      img {
        position: absolute;
        right: -30px;
        top: 0px;
      }
    }
  }
}
.date-list {
  padding: 0 10px 0px;
  .date-list-item {
    min-height: 50px;
    display: flex;
    .class-info {
      width: 27%;
      background-color: rgb(248, 248, 248);
      position: relative;
      .class-info-text-box {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        .build-name {
          font-size: 12px;
          margin-bottom: 5px;
        }
        .class-name {
          font-size: 15px;
        }
      }
      .border-bottom {
        position: absolute;
        width: 80%;
        height: 1px;
        bottom: 0;
        left: 10%;
        background-color: rgb(237, 237, 237);
      }
    }
    .time-list {
      min-height: 50px;
      padding: 12px;
      background-color: rgb(248, 248, 248);
      text-align: center;
      width: 70%;
      margin-left: 3%;
      margin-bottom: 5px;
      font-size: 12px;
      height: 95%;
      p {
        margin-bottom: 10px;
      }
      p:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .date-list-item:last-child .time-list {
    margin-bottom: 0px;
  }
}
.search-form {
  margin-top: 10px;
}
.state{
        color: rgb(243, 224, 21) !important;
      }
</style>
